import { Action } from '@ngrx/store';
import { AtencionData } from '../models/store.model';

export const SETATENCIONDATA = '[AtencionData] Set Data';
export const UNSETATENCIONDATA = '[AtencionData] Unset Data';

export class SetAtencionData implements Action {
    readonly type = SETATENCIONDATA;
    constructor(public atencion: AtencionData) { }
}

export class UnsetAtencionData implements Action {
    readonly type = UNSETATENCIONDATA;
}

export type AtencionDataActions =
    | SetAtencionData
    | UnsetAtencionData;
